import { render } from "./Samples.vue?vue&type=template&id=32e86c96&scoped=true&ts=true"
import script from "./Samples.vue?vue&type=script&lang=ts"
export * from "./Samples.vue?vue&type=script&lang=ts"

import "./Samples.vue?vue&type=style&index=0&id=32e86c96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e86c96"]])

export default __exports__